import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import './design/app.css';
import './design/polish.css';
import { installWallpaper } from './design/wallpaper';
import { language, setLanguage } from './i18n/i18n';
import { App } from './ui/App';
import { applyTheme, storedTheme } from './ui/theme';

applyTheme(storedTheme());
setLanguage(language());
installWallpaper();

// The offline shell (public/sw.js) — production builds only: in dev it would cache Vite's modules.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('[satori] sw', e)));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
